import BillToPayReleaseAttachmentList from '@/components/Financial/BillToPay/ReleaseAttachmentList';
import { useBillToPayReleaseDetailContext } from '@/components/Financial/BillToPay/ReleaseDetailProvider';
import FinancialAttachmentModal from '@/components/Financial/FinancialAttachmentModal';
import { DefaultRouteTabs } from '@/components/_common';
import { useAccountPayableArchiveCreate } from '@/core/domain/financial/AccountPayable/AccountPayable.hooks';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Button } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function BillToPayReleasesAttachmentPage({ route }: PageProps) {
  const intl = useIntl();

  const { installmentPayableId, accountPayableId } =
    useBillToPayReleaseDetailContext();

  const [modalOpen, modalAction] = useDisclosure(false);

  const accountArchiveCreate = useAccountPayableArchiveCreate();

  async function handleSubmit(files: File[]) {
    try {
      await accountArchiveCreate.mutateAsync({
        accountPayableId,
        files,
      });
    } catch {}
  }

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <DefaultRouteTabs
        permissions={route.permissions}
        route={{ ...route.parent, key: route.key }}
        baseKey={installmentPayableId.toString()}
        basePath={window.location.pathname.replace('/attachments', '')}
        extra={
          <Button type="primary" onClick={modalAction.open}>
            Adicionar anexos
          </Button>
        }
      >
        <p style={{ marginBottom: 24 }}>
          Visualize, cadastre, ou remova os anexos vinculados a sua conta
        </p>

        <BillToPayReleaseAttachmentList />
      </DefaultRouteTabs>

      <FinancialAttachmentModal
        onSubmit={handleSubmit}
        open={modalOpen}
        onClose={modalAction.close}
      />
    </>
  );
}
